import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BellIcon from "../../../assets/icons/BellIcon";
import BookmarkIcon from "../../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import Checkbox from "../../../common/Checkbox";
import { Box } from "@mui/material";
import { SecondaryButton } from "../../../common/Buttons";
import LayoutWrapper from "../../../common/LayoutWrapper";
import KebabIcon from "./../../../assets/icons/kebabmenu.png";
import tick from "../../../assets/icons/tick.png";

import "./index.scss";
import { Transform } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";

const dummyData = [
  {
    id: 1,
    branch: "Pforzheim ",
    name: "Max Müller",
    dob: "16/04/1952",
    time: "7:25 Am",
    status: true,
    adviser: "Max mullar",
    isChecked: true,
    isMarked: true,
  },
  {
    id: 2,
    branch: "Pforzheim ",
    name: "Tobias Schmidt",
    dob: "20/01/1970 ",
    time: "9:25 Am",
    status: false,

    isChecked: false,
    isMarked: false,
  },
  {
    id: 3,
    branch: "Pforzheim ",
    name: "jack",
    dob: "16/04/1959",
    time: "11:25 Am",
    status: true,
    adviser: "Yerim Moon",
    isChecked: false,
    isMarked: false,
  },
  {
    id: 4,
    branch: "Pforzheim ",
    name: "Tobias Schmidt",
    time: "9:25 Am",
    dob: "20/01/1970 ",
    status: true,
    adviser: "Max mullar",
    isChecked: true,
    isMarked: true,
  },
  {
    id: 5,
    branch: "Pforzheim ",
    name: "Max Müller",
    dob: "16/04/1952",
    time: "7:25 Am",
    status: true,
    adviser: "Max mullar",
    isChecked: false,
    isMarked: false,
  },
  {
    id: 6,
    branch: "Pforzheim ",
    name: "Ute Schneider",
    dob: "05/05/1950",
    time: "4:25 Am",
    status: false,

    isChecked: false,
    isMarked: false,
  },
  {
    id: 7,
    branch: "Pforzheim ",
    name: "Tobias Schmidt",
    dob: "20/01/1970 ",
    time: "9:25 Am",
    status: true,
    adviser: "Yerim Moon",
    isChecked: false,
    isMarked: false,
  },
  {
    id: 8,
    branch: "Pforzheim ",
    name: "Max Müller",
    dob: "16/04/1952",
    time: "7:25 Am",
    status: false,

    isChecked: false,
    isMarked: false,
  },
];
const TickIcon = () => {
  return (
    <Box
      sx={{
        height: "20px",
        width: "20px",
        borderRadius: "50%",
        background: "#77C790",
        position: "relative",
        boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.15)",
      }}
    >
      <Box
        component="img"
        src={tick}
        width="14px"
        sx={{
          cursor: "pointer",
          zIndex: 2,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      />
    </Box>
  );
};
const NewButton = () => {
  return (
    <SecondaryButton
      color="#000000"
      padding="5px 10px"
      title={t("new")}
      border="2px solid #77C790"
      textTransform="initial"
      fontSize="13px"
      fontWeight="500"
      hoverBgColor="#77C790"
    />
  );
};
const Report = () => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [list, setList] = useState(dummyData);

  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.id == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  return (
    <>
      <div className="cases">
        <div className="input-wrapper">
          <input
            placeholder={t(getKeyFromText("Name, Surname, date of birth"))}
            className="custom-input"
          />
          <SearchIcon className="search-icon" />
        </div>
        <button type="button" className="filter-btn">
          {t("filter")}
        </button>
      </div>
      <div className="" style={{ maxHeight: "500px", overflow: "auto" }}>
        <TableContainer component={Paper}>
          <Box
            sx={{
              display: "flex",
              padding: "19px 16px",
              width: "max-content",
            }}
          >
            <DeleteIcon
              type={"filled"}
              style={{
                margin: "auto 0",
                width: "20px",
                fill: "black",
                cursor: "pointer",
              }}
            />
            <Box
              component="div"
              sx={{
                display: "flex",
                justifyCotent: "center",
                alignItems: "center",
                fontWeight: "400",
                marginRight: "30px",
                marginLeft: "80px",
              }}
            >
              <BookmarkIcon
                type={"filled"}
                style={{
                  width: "20px",
                  fill: "black",
                  cursor: "pointer",
                }}
              />
              {t("marked-report")}
            </Box>
            <Box
              component="div"
              sx={{
                display: "flex",
                justifyCotent: "center",
                alignItems: "center",
                fontWeight: "400",
              }}
            >
              <DeleteIcon
                type={"filled"}
                style={{
                  width: "20px",
                  fill: "black",
                  cursor: "pointer",
                }}
              />
              {t("deleted-report")}
            </Box>
          </Box>

          <Table
            sx={{
              minWidth: 650,

              maxHeight: "300px",
              overflow: "auto",
              "th , td": { border: "none", padding: "8px 16px" },
              th: {
                padding: "10px 16px",
                borderBottom: "1px solid #DEDEDE",
                borderTop: "1px solid #DEDEDE",
              },
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "50px" }} align="right"></TableCell>
                <TableCell sx={{ width: "40px" }}></TableCell>
                <TableCell sx={{}}>{t("branch")}</TableCell>
                <TableCell>{t("soi-heading-2")}</TableCell>
                <TableCell>{t("input-2")}</TableCell>
                <TableCell>{t("req-time")}</TableCell>
                <TableCell align="left" sx={{}}>
                  {t("status")}
                </TableCell>
                <TableCell>{t("contact")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((item) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell align="right">
                      <div
                        style={{
                          marginTop: "-8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Checkbox
                          id={item.id}
                          checked={item.isChecked}
                          onChange={handleChangeCheck}
                        />
                      </div>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          justifyCotent: "center",
                          alignItems: "center",
                          fontWeight: "400",
                        }}
                      >
                        <BookmarkIcon
                          type={item.isMarked ? "filled" : "outlined"}
                          style={{
                            //marginRight: "20px",
                            width: "20px",
                            display: "flex",
                            alignItems: "center",
                            fill: item.isMarked ? "#FFD76C" : "",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickBookmark(item);
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{item.branch}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.dob}</TableCell>
                    <TableCell>{item.time}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          width: "max-content",
                        }}
                      >
                        {item.status ? (
                          <>
                            <TickIcon />

                            {item.adviser}
                          </>
                        ) : (
                          <NewButton />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        component={"img"}
                        sx={{ height: "20px" }}
                        src={KebabIcon}
                      ></Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default Report;
